import PropTypes from 'prop-types';
import { createContext, useMemo, useState } from 'react';

export const AppBarContext = createContext();

export const AppBarContextProvider = ({ children }) => {
  const [barHeight, setBarHeight] = useState(0);

  const appBarValues = useMemo(
    () => ({
      barHeight,
      setBarHeight,
    }),
    [barHeight],
  );

  return (
    <AppBarContext.Provider value={appBarValues}>
      {children}
    </AppBarContext.Provider>
  );
};

AppBarContextProvider.propTypes = {
  children: PropTypes.element,
};
